module.exports = __webpack_public_path__ + "fonts/SourceSansPro-Regular.ttf.090c51d7.woff";